import React from 'react';
import {WidgetProps} from '../types';

const DateWidget: React.FC<WidgetProps> = ({}) => {
    return null; // TODO
};

export default DateWidget;
